export const stringFields = [
  "title",
  "subtitle",
  "socialImage",
  "logoAlt",
  "metaTitle",
  "metaDescription",
  "sowLogo",
  "bkgImg",
  "bannerVideoUrl",
  "orderNowUrl",
  "meetTheOwners",
  "fullName",
  "addressTop",
  "addressBottom",
  "email",
  "phone",
  "hours",
  "registry",
  "featuredHeading",
  "featuredDescription",
  "drinksHeading",
  "drinksDescription",
  "instagram",
  "facebook",
  "tiktok",
];
export function safeUrl(value) {
  return (
    typeof value === "string" &&
    (!value ||
      (/^https:\/\//i.test(value) && !/[\u0000-\u0020\\]/.test(value)) ||
      (/^\/(?![\/\\])/.test(value) && !/[\\\u0000-\u0020]/.test(value)))
  );
}
export function validateContent(pageId, content) {
  const errors = [];
  const pending = [{ value: content, depth: 0 }];
  const urlFields = new Set([
    "img",
    "link",
    "href",
    "firstImg",
    "secondImg",
    "thirdImg",
    "socialImage",
    "sowLogo",
    "bkgImg",
    "bannerVideoUrl",
    "orderNowUrl",
    "meetTheOwners",
  ]);
  while (pending.length) {
    const { value, depth } = pending.pop();
    if (depth > 30) return ["Content nesting is too deep."];
    if (!value || typeof value !== "object") continue;
    for (const [key, child] of Object.entries(value)) {
      if (urlFields.has(key) && !safeUrl(child))
        errors.push(`${key}: use HTTPS or a site-relative URL.`);
      if (child && typeof child === "object")
        pending.push({ value: child, depth: depth + 1 });
    }
  }
  if (!content || typeof content !== "object" || Array.isArray(content))
    return ["Invalid content object."];
  if (content.announcement !== undefined) {
    const notice = content.announcement;
    if (
      !notice ||
      typeof notice.enabled !== "boolean" ||
      typeof notice.message !== "string" ||
      notice.message.length > 300 ||
      (notice.enabled && !notice.message.trim())
    )
      errors.push(
        "Banner: enter a message of 1–300 characters, or turn the banner off."
      );
  }
  for (const field of stringFields)
    if (typeof content[field] !== "string" || content[field].length > 20000)
      errors.push(`${field}: expected text under 20,000 characters.`);
  for (const key of [
    "socialImage",
    "sowLogo",
    "bkgImg",
    "bannerVideoUrl",
    "orderNowUrl",
    "meetTheOwners",
    "instagram",
    "facebook",
    "tiktok",
  ])
    if (!safeUrl(content[key]))
      errors.push(`${key}: use HTTPS or a site-relative URL.`);
  if (!Array.isArray(content.categories) || content.categories.length > 50)
    return [...errors, "Invalid menu categories."];
  const ids = new Set();
  for (const category of content.categories) {
    if (
      !category ||
      typeof category.id !== "string" ||
      !category.id ||
      ids.has(category.id)
    )
      errors.push("Category IDs must be unique.");
    ids.add(category?.id);
    if (
      typeof category?.title !== "string" ||
      !category.title.trim() ||
      typeof category.visible !== "boolean" ||
      !Array.isArray(category.items) ||
      category.items.length > 500
    ) {
      errors.push("Invalid category.");
      continue;
    }
    for (const item of category.items) {
      if (
        !item ||
        typeof item.id !== "string" ||
        !item.id ||
        ids.has(item.id)
      ) {
        errors.push("Item IDs must be unique.");
        continue;
      }
      ids.add(item.id);
      for (const key of [
        "title",
        "description",
        "subtitle",
        "img",
        "alt",
        "price",
        "link",
      ])
        if (typeof item[key] !== "string" || item[key].length > 20000)
          errors.push(`Invalid item ${key}.`);
      if (!item.title?.trim()) errors.push("Every menu item needs a name.");
      if (typeof item.visible !== "boolean") errors.push("Invalid visibility.");
      if (
        item.price &&
        !/^\$?\d+(?:\.\d{1,2})?(?:\s*\|\s*\$?\d+(?:\.\d{1,2})?)*$/.test(
          item.price
        )
      )
        errors.push(`${item.title}: invalid price.`);
      if (item.img && !item.alt?.trim())
        errors.push(`${item.title}: image description required.`);
      if (!safeUrl(item.img) || !safeUrl(item.link))
        errors.push(`${item.title}: invalid URL.`);
      if (
        !Array.isArray(item.includes) ||
        item.includes.some(
          (part) => !part || typeof part.item !== "string" || !safeUrl(part.img)
        )
      )
        errors.push("Invalid included sides.");
    }
  }
  for (const key of ["checkUsOut", "whatOurGuestsSay"]) {
    const section = content[key];
    if (
      !section ||
      typeof section.title !== "string" ||
      typeof section.content !== "string" ||
      typeof section.visible !== "boolean"
    ) {
      errors.push(`Invalid ${key} section.`);
      continue;
    }
    for (const field of ["firstImg", "secondImg", "thirdImg"])
      if (!safeUrl(section[field])) errors.push(`${key}: invalid image URL.`);
    for (const field of ["firstAlt", "secondAlt", "thirdAlt"])
      if (typeof section[field] !== "string")
        errors.push(`${key}: invalid image description.`);
  }
  if (
    !Array.isArray(content.navigation) ||
    content.navigation.length > 20 ||
    content.navigation.some(
      (link) =>
        !link ||
        typeof link.id !== "string" ||
        typeof link.title !== "string" ||
        !link.title.trim() ||
        !safeUrl(link.href) ||
        !link.href ||
        typeof link.visible !== "boolean"
    ) ||
    new Set(content.navigation.map((link) => link.id)).size !==
      content.navigation.length
  )
    errors.push("Invalid navigation links.");
  for (const key of ["featuredItemIds", "featuredDrinkIds"])
    if (
      !Array.isArray(content[key]) ||
      content[key].some((id) => typeof id !== "string") ||
      new Set(content[key]).size !== content[key].length
    )
      errors.push("Invalid featured item references.");
  if (typeof content.useMenuReferences !== "boolean")
    errors.push("Invalid featured item mode.");
  if (pageId === "menu" && !content.title?.trim())
    errors.push("Menu title is required.");
  return errors;
}
